import { useEffect, useRef } from 'react';

// For a handler bound once: it reads the latest render's value through the ref instead of being bound again.
export const useLatest = <T>(value: T) => {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref;
};
